import Vue from 'vue';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import './helpers/filters';

Vue.config.productionTip = false;

if (process.env.NODE_ENV === 'production') {
  Raven.config('https://38d022a3992c4c239b0b5a73f8bf771a@sentry.applover.pl/50', { ignoreUrls: [/\S*localhost\S*/] })
    .addPlugin(RavenVue, Vue)
    .install();
}

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
